import React, {PureComponent} from 'react';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    /**
     * if provided, will wrap button in <Link /> component.
     *
     * @todo
     */
    to?: string;
}

export class ButtonBase extends PureComponent<ButtonProps> {
    public render() {
        const {to, ...props} = this.props;

        if (to) {
            // TODO: use Link instead
        }

        return <button {...props} />;
    }
}
